module.exports = __webpack_public_path__ + "static/media/Niveau_elN4_4_524038.eef6153c.png";